import { Link } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import { users } from "../../context/users";

function Home() {
  return (
    <div>
      <h1>لیست کاربران</h1>
      {users.map((user) => (
        <div key={user.id} style={{ marginBottom: "20px" }}>
          <h3>{user.name}</h3>
          <QRCodeCanvas value={`http://localhost:3000/profile/${user.id}`} />
          <br />
          <Link to={`/profile/${user.id}`}>مشاهده پروفایل</Link>
        </div>
      ))}
    </div>
  );
}

export default Home;
